import React from 'react'
import IconTick from '@svgs/IconTick'
import Spacer from '@components/Spacer'
import {
    RadioContainer,
    RadioTick,
    RadioLabel,
    InputRadio,
    Title,
    FieldContainer,
    SubTitle
} from './index.style'

const Radio = ({
    title,
    name,
    value,
    requierd,
    checked,
    onChange,
    values,
    subTitle,
    children
}) => {
    return (
        <FieldContainer>
            {title && <Title>{title}</Title>}
            {subTitle && <SubTitle>{subTitle}</SubTitle>}
            <Spacer size={[10, 20]} />
            {values.map((item) => (
            <RadioContainer>
                <InputRadio onChange={onChange} id={`${name}-${item}`} name={name} value={item} type="radio"></InputRadio>
                <RadioTick className="tick"></RadioTick>
                <RadioLabel>{item}</RadioLabel>
            </RadioContainer>
            ))}
        </FieldContainer>
    )
}
export default Radio